import { render } from "./SimilarInterestingHeader.vue?vue&type=template&id=419f11e8&scoped=true"
import script from "./SimilarInterestingHeader.vue?vue&type=script&lang=js"
export * from "./SimilarInterestingHeader.vue?vue&type=script&lang=js"

import "./SimilarInterestingHeader.vue?vue&type=style&index=0&id=419f11e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419f11e8"]])

export default __exports__